module.exports = __webpack_public_path__ + "static/media/ic_favorite_filled.edbbf5d4.svg";